import React, { useContext } from 'react';

import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'styled-components';

import { Typography } from '@pkg/components/DesignSystem';
import { ReactComponent as EthIcon } from '@pkg/components/Sections/Profile/icons/eth.svg';

import { type NFTFloorPrice } from '@app/store/types/yat-page-actions';

import { EthWrapper, NftFloorPriceWrapper, StyledEthDarkIcon, StyledPriceWrapper, StyledTypography } from './styles';

export interface NftFloorPriceProps {
    floorPrice: NFTFloorPrice;
    selected?: boolean;
}

export function NftFloorPrice({ floorPrice, selected = false }: NftFloorPriceProps) {
    const { t: translate } = useTranslation(['yat_nft_manager']);
    const theme = useContext(ThemeContext);

    const isLongNumber = floorPrice.value.toString().length > 4;

    // If ever we support different currencies (other than `eth`)
    // we will need to have some dymanic logic to select the correct icon.
    const ethDarkIcon = selected ? (
        <StyledEthDarkIcon
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: theme.transitions.speeds.normal }}
        />
    ) : null;

    return (
        <NftFloorPriceWrapper>
            <StyledTypography $longNumber={isLongNumber}>{translate('yat_nft_manager_floor_price')}</StyledTypography>

            <StyledPriceWrapper>
                <EthWrapper>
                    <EthIcon />
                    <AnimatePresence>{ethDarkIcon}</AnimatePresence>
                </EthWrapper>

                <Typography type="label" align="left">
                    {floorPrice.value}
                </Typography>
            </StyledPriceWrapper>
        </NftFloorPriceWrapper>
    );
}
